import { Button } from 'components/button/Button';
import React from 'react';
import ClockIcon from 'assets/apply.clevry/Icon_Label_Clock.png';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

type ViewApplicationStagesDetailsFooterProps = {
  time: string;
  date: string;
  Button1Text?: string;
  Button2Text?: string;
  Button1OnClick?: () => void;
  Button2OnClick?: () => void;
};

export const ViewApplicationStagesDetailsFooter: React.FC<
  ViewApplicationStagesDetailsFooterProps
> = ({
  time,
  date,
  Button1Text,
  Button2Text,
  Button1OnClick,
  Button2OnClick,
}) => {
  const { t } = useTranslation('View+Application+Stages+Details+Footer', {
    i18n,
  });

  return (
    <div className="ViewApplicationSummaryDetailsFooter">
      <div className="ViewApplicationSummaryDetailsFooter__DateTime">
        <img src={ClockIcon} />
        <span className="ViewApplicationSummaryDetailsFooter__Time">
          {time}
        </span>
        <span className="ViewApplicationSummaryDetailsFooter__Date">
          {date}
        </span>
      </div>
      {Button1Text && Button1OnClick && (
        <Button onClick={Button1OnClick} priority="tertiary">
          {Button1Text}
        </Button>
      )}
      {Button2Text && Button2OnClick && (
        <Button onClick={Button2OnClick} priority="tertiary">
          {Button2Text}
        </Button>
      )}
    </div>
  );
};
